import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHelperService } from '../../services/TranslateService';
import { UserService } from '../../dataServices/userService';
import { User } from '../../models/user';
import { AppState } from '../../services/app.service';
import { SubdomainConfigService, ContactInfo } from 'src/app/services/subdomainConfig.service';

@Component({
    selector: 'self-ins-verification',
    templateUrl: './verification-page.component.html',
    styleUrls: ['./verification-page.component.scss'],
    standalone: false
})
export class VerificationPageComponent {
    @ViewChild('form', { static: false }) public form: NgForm | undefined = undefined;
    public user: User | undefined;
    public email: string = '';
    public supportEmail: string = '';
    public constructor(private router: Router,
                       private userService: UserService,
                       private appState: AppState,
                       public _translateService: TranslateHelperService,
                       private subdomainConfigService: SubdomainConfigService) {
        this.userService.getUserVerificationInfo().subscribe((data) => {
            this.user = this.appState.user.getValue();
            this.user.verificationInfo = data;
            this.appState.updateUser(this.user);

            const contactInfo: ContactInfo = this.subdomainConfigService.getContactInfo();
            this.email = contactInfo.email;
            this.supportEmail = contactInfo.supportEmail;
        })
    }

    public onSubmit() {
        this.userService.getQuote().subscribe((data) => {
            if (data) {
                if (this.user && this.user.status === 'provisioning') {
                    this.router.navigate(['/verification-tractors', data.qnum, data.qsuffix]);
                    return;
                }
                this.router.navigate(['/coverage']);
            }
        })
    
    }

    public gotoHome() {
        this.router.navigate(['/coverage']);
    }
}